export default __webpack_public_path__ + "static/media/event3.b185690d.jpg";